import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import * as Renders from "../../../../component/AdvancedFiltersRenders";
import { useSetRecoilState } from "recoil";
import { STATE_ACTIVE_FILTERS } from "../atoms/CollectionAtoms";
import {
    ID_FILTER_COLLECTION_DATE_FROM,
    ID_FILTER_COLLECTION_DATE_TO,
    ID_FILTER_MANDATE_TYPE,
    ID_FILTER_MESSAGE_ID,
    ID_FILTER_REPORT_DATE_FROM,
    ID_FILTER_REPORT_DATE_TO,
    ID_FILTER_REPORT_TYPE,
    ID_FILTER_STATUS,
    MANDATE_TYPES,
    REPORT_TYPES,
    STATUSES
} from "../../constants/CollectionConstants";
import AdvancedFilter from "../../../../component/AdvancedFilter";
import { addFilter } from "../../../../utils/FilterUtils";

function ThresholdConfigurationFilter() {
    const { t } = useTranslation("finance", { keyPrefix: "sdd.collections" });

    const setFilters = useSetRecoilState(STATE_ACTIVE_FILTERS);
    const schema = Yup.object().shape({
        [ID_FILTER_MESSAGE_ID]: Yup.string().max(
            128,
            t("filters.errors.invalid-length")
        ),
        [ID_FILTER_REPORT_DATE_FROM]: Yup.date().nullable().test("testFrom", t('filters.errors.invalid-report-date-from'), (value, context) => {
            console.log(context)
            return !value || !context.parent.reportDateTo || (value <= context.parent.reportDateTo);
        }).test('date-range', t('filters.errors.invalid-report-date-from'), function (value) {
            const { dateTo } = this.parent;
            return !value || !dateTo || value <= dateTo;
        }).typeError(t('filters.errors.invalid-report-date-from')),
        [ID_FILTER_REPORT_DATE_TO]: Yup.date().nullable().test("testTo", t('filters.errors.invalid-report-date-to'), (value, context) => {
            return !value || !context.parent.reportDateFrom || (value >= context.parent.reportDateFrom);
        }).test('date-range', t('filters.errors.invalid-report-date-to'), function (value) {
            const { dateFrom } = this.parent;
            return !value || !dateFrom || value >= dateFrom;
        }).typeError(t('filters.errors.invalid-report-date-to')),        
        [ID_FILTER_COLLECTION_DATE_FROM]: Yup.date().nullable().test("testFrom", t('filters.errors.invalid-collection-date-from'), (value, context) => {
            console.log(context)
            return !value || !context.parent.collectionDateTo || (value <= context.parent.collectionDateTo);
        }).test('date-range', t('filters.errors.invalid-collection-date-from'), function (value) {
            const { dateTo } = this.parent;
            return !value || !dateTo || value <= dateTo;
        }).typeError(t('filters.errors.invalid-collection-date-from')),
        [ID_FILTER_COLLECTION_DATE_TO]: Yup.date().nullable().test("testTo", t('filters.errors.invalid-collection-date-to'), (value, context) => {
            return !value || !context.parent.collectionDateFrom || (value >= context.parent.collectionDateFrom);
        }).test('date-range', t('filters.errors.invalid-collection-date-to'), function (value) {
            const { dateFrom } = this.parent;
            return !value || !dateFrom || value >= dateFrom;
        }).typeError(t('filters.errors.invalid-collection-date-to')),

    });

    const defaultValues = {
        [ID_FILTER_REPORT_TYPE]: "",
        [ID_FILTER_MANDATE_TYPE]: "",
        [ID_FILTER_STATUS]: "",
        [ID_FILTER_REPORT_DATE_FROM]: null,
        [ID_FILTER_REPORT_DATE_TO]: null,
        [ID_FILTER_COLLECTION_DATE_FROM]: null,
        [ID_FILTER_COLLECTION_DATE_TO]: null,
        [ID_FILTER_MESSAGE_ID]: ""
    };

    const fields = {
        main: {
            [ID_FILTER_REPORT_TYPE]: Renders.renderSelect(
                ID_FILTER_REPORT_TYPE,
                t("filters." + ID_FILTER_REPORT_TYPE),
                REPORT_TYPES.map((x) => {
                    return { ...x, label: t(x.label) };
                })
            ),
            [ID_FILTER_MANDATE_TYPE]: Renders.renderSelect(
                ID_FILTER_MANDATE_TYPE,
                t("filters." + ID_FILTER_MANDATE_TYPE),
                MANDATE_TYPES.map((x) => {
                    return { ...x, label: t(x.label) };
                })
            ),
            [ID_FILTER_STATUS]: Renders.renderSelect(
                ID_FILTER_STATUS,
                t("filters." + ID_FILTER_STATUS),
                STATUSES.map((x) => {
                    return { ...x, label: t(x.label) };
                })
            )
        },
        adv: {
            [ID_FILTER_REPORT_DATE_FROM]: Renders.renderDatePickerFrom(
                ID_FILTER_REPORT_DATE_FROM,
                t("filters." + ID_FILTER_REPORT_DATE_FROM)
            ),
            [ID_FILTER_REPORT_DATE_TO]: Renders.rendereDatePickerTo(
                ID_FILTER_REPORT_DATE_TO,
                t("filters." + ID_FILTER_REPORT_DATE_TO)
            ),
            [ID_FILTER_COLLECTION_DATE_FROM]: Renders.renderDatePickerFrom(
                ID_FILTER_COLLECTION_DATE_FROM,
                t("filters." + ID_FILTER_COLLECTION_DATE_FROM)
            ),
            [ID_FILTER_COLLECTION_DATE_TO]: Renders.rendereDatePickerTo(
                ID_FILTER_COLLECTION_DATE_TO,
                t("filters." + ID_FILTER_COLLECTION_DATE_TO)
            ),
            [ID_FILTER_MESSAGE_ID]: Renders.renderTextField(
                ID_FILTER_MESSAGE_ID,
                t("filters." + ID_FILTER_MESSAGE_ID),

            )
        }
    };

    const submit = (data: any) => {
        Object.keys(defaultValues)
            .forEach((param) => {
                addFilter(setFilters, param, data[param]);
            });
    };

    const reset = () => {
        setFilters([]);
    };

    return (
        <AdvancedFilter
            schema={schema}
            mainFields={fields.main}
            fields={fields.adv}
            defaultValues={defaultValues}
            onSubmit={submit}
            onReset={reset}

        />
    );
}

export default ThresholdConfigurationFilter;
